var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content", attrs: { type: "primary" } },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "410015203",
                reset: true,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                ),
                "auto-init": _vm.searchItemAutoInit,
                "custom-search-items": _vm.customSearchItems,
                no: "1"
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_BillOverseasSCenter_writeOffs"
                          ]),
                          expression:
                            "$checkPermission(['button_BillOverseasSCenter_writeOffs'])"
                        }
                      ],
                      attrs: { type: "primary", no: "2" },
                      on: {
                        click: function($event) {
                          return _vm.overseaBtnEventHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WriteOff")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_BillOverseasSCenter_billOverseasReturn"
                          ]),
                          expression:
                            "$checkPermission(['button_BillOverseasSCenter_billOverseasReturn'])"
                        }
                      ],
                      attrs: { type: "primary", no: "3" },
                      on: {
                        click: function($event) {
                          return _vm.toReturn()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Return")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "4" },
                      on: {
                        click: function($event) {
                          return _vm.onPrint()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                  ),
                  _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_BillOverseasSCenter_importAndQuery"
                          ]),
                          expression:
                            "$checkPermission(['button_BillOverseasSCenter_importAndQuery'])"
                        }
                      ],
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "5px"
                      },
                      attrs: {
                        action: _vm.URL.act.billing.importAndQueryBilling,
                        headers: { sessionId: _vm.sessionId },
                        "show-file-list": false,
                        accept: ".xls, .xlsx",
                        "on-success": _vm.importSuccess,
                        no: "5"
                      }
                    },
                    [
                      _c("el-button", { attrs: { type: "primary", no: "6" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_ImportAndQueryOfBillNumber")
                          )
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "410015203",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "410015203",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-select-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          ctx: _vm.templateSelectorDialog.ctx
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.writeOffDialog.visible
        ? _c("write-off-dialog", {
            ref: "dgWriteoff",
            attrs: {
              location: _vm.location,
              visible: _vm.writeOffDialog.visible,
              title: _vm.title,
              params: _vm.writeOffDialog.params,
              properties: this.properties
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.writeOffDialog, "visible", $event)
              },
              writeoffSuccessHandler: _vm.writeoffSuccessHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }